<footer id="footer">
    <div class="footer_inner container">
        <div>
            <span class="copyright">&copy; Copyright Om Sai Enterprises 2021</span> 
            <span>Design by <a href="#">Kiran Kumawat</a></span>
        </div>
    </div>
</footer>